import apiClient from '../client';
import { User, UserStatus } from '@shared/types';

export interface UpdateUserData {
  email?: string;
  isApproved?: boolean;
  isLockedOut?: boolean;
  roles?: string[];
  firstName?: string;
  lastName?: string;
  canMessage?: boolean;
  status?: UserStatus;
  twoFactorEnabled?: boolean;
}

export interface CreateUserData {
  username: string;
  email: string;
  password: string;
  isApproved?: boolean;
  roles?: string[];
}

export interface ActiveUser {
  UserId: string;
  UserName: string;
  FirstName: string | null;
  LastName: string | null;
  Status: UserStatus;
}

export const userService = {
  getAllUsers: async (): Promise<User[]> => {
    const response: any = await apiClient.get('/users');
    return response.data;
  },

  getActiveUsers: async (): Promise<ActiveUser[]> => {
    const response: any = await apiClient.get('/users/active');
    return response.data;
  },

  getUserById: async (id: string): Promise<User> => {
    const response: any = await apiClient.get(`/users/${id}`);
    return response.data;
  },

  updateUser: async (id: string, data: UpdateUserData): Promise<User> => {
    const response: any = await apiClient.put(`/users/${id}`, data);
    return response.data;
  },

  getAllRoles: async (): Promise<string[]> => {
    const response: any = await apiClient.get('/users/roles');
    return response.data;
  },

  createUser: async (data: CreateUserData): Promise<User> => {
    const response: any = await apiClient.post('/users', data);
    return response.data;
  },

  deleteUser: async (id: string): Promise<void> => {
    await apiClient.delete(`/users/${id}`);
  },

  getMyStatus: async (): Promise<UserStatus> => {
    const response: any = await apiClient.get('/users/me/status');
    return response.data.status;
  },

  updateMyStatus: async (status: UserStatus): Promise<void> => {
    await apiClient.put('/users/me/status', { status });
  },
};
